import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';

import { TmsWebBaseEditService } from '../base';
import {
  ApiResult,
  OrderLineStockCut,
  StockForCutting,
  StockForCuttingComments,
  StockForCuttingCommentsUpdate,
  StockForCuttingDetails,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class StockForCuttingService extends TmsWebBaseEditService<StockForCutting, StockForCuttingDetails> {
  public refreshDetails = new Subject<void>();
  public refreshComments = new ReplaySubject<StockForCuttingCommentsUpdate>();

  constructor() {
    super('StockForCutting', $localize`Stock for Cutting`);
  }

  createCuttingRecord(salesOrderStockAllocationId: string): Observable<ApiResult> {
    return this.httpService.get<ApiResult>(
      `${this.apiUrl}/CreateCuttingRecord?salesOrderStockAllocationId=${salesOrderStockAllocationId}`,
    );
  }

  createPurchaseCuttingRecord(purchaseOrderStockAllocationId: string): Observable<ApiResult> {
    return this.httpService.get<ApiResult>(
      `${this.apiUrl}/CreatePurchaseCuttingRecord?purchaseOrderStockAllocationId=${purchaseOrderStockAllocationId}`,
    );
  }

  getComments(stockItemId: string, salesOrderLineId: string): Observable<StockForCuttingComments> {
    return this.httpService.get<StockForCuttingComments>(
      `${this.apiUrl}/GetComments?stockItemId=${stockItemId}&salesOrderLineId=${salesOrderLineId ?? ''}`,
    );
  }

  // Both return an ApiResult: `data` is the allocation id (used for the labels) and `warnings`
  // carries the summary of what the cut actually did — which roll the stock moved to and what is
  // left — because the panel resets itself afterwards and used to leave no trace of it.
  updateCut(model: OrderLineStockCut): Observable<ApiResult> {
    return this.httpService.post<ApiResult>(`${this.apiUrl}/UpdateCut`, model);
  }

  updatePurchaseCut(model: OrderLineStockCut): Observable<ApiResult> {
    return this.httpService.post<ApiResult>(`${this.apiUrl}/UpdatePurchaseCut`, model);
  }

  // All the paperwork of a cut (despatch item, statuses, labels) with NO stock deducted - the
  // piece came from an unidentified remnant. Sales allocations only.
  takeFromRemnant(model: OrderLineStockCut): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/TakeFromRemnant`, model);
  }
}
